export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#1A1A1A]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <img src="/rtb-logo.png?v=2" alt="Right To Bear" className="h-16 w-auto object-contain" />
            <span className="flex flex-col leading-none">
              <span className="font-display text-xl tracking-tight">RIGHT TO BEAR</span>
              <span className="text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--rtb-copper))] font-medium mt-1">
                Pure Peace of Mind
              </span>
            </span>
          </div>
          <p className="text-white/40 text-sm max-w-xs leading-relaxed">
            The internal scheduling command center for Right To Bear representatives.
            Claim your event. Represent the association.
          </p>
        </div>
        <div>
          <div className="overline text-white/40 mb-3">Event Types</div>
          <ul className="space-y-2 text-white/60 text-sm">
            <li>Workshops</li>
            <li>Concealed Carry Classes</li>
            <li>Table Events</li>
            <li>SHOOT SIG</li>
            <li>Protect His House</li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/40 mb-3">Reps Only</div>
          <p className="text-white/60 text-sm leading-relaxed">
            Booked events lock instantly. Text reminders keep you sharp before every event.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center overline text-white/30">
        © {new Date().getFullYear()} Right To Bear Association — Internal Use
      </div>
    </footer>
  );
}
